import { DOCUMENT, Location } from '@angular/common';
import { ChangeDetectionStrategy, Component, Inject, NgZone, OnDestroy, OnInit, Renderer2 } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatExpansionModule } from '@angular/material/expansion';
import { Router, RouterLink } from '@angular/router';
import { I18NextModule } from 'angular-i18next';
import { BaseComponent } from 'src/app/_shared/components/base/base.component';
import { HeroComponent } from 'src/app/_shared/components/hero/hero.component';
import { IconComponent } from 'src/app/common/icon/icon.component';
import { METADATA_SERVICE, MetadataService } from 'src/app/common/metadata/metadata.service';
import { NotLoggedService } from 'src/app/common/not-logged/not-logged.service';
import { RouteTranslatePipe } from 'src/app/_shared/pipes/route-translate.pipe';
import { RouteTranslateService } from 'src/app/common/route-translate/route-translate.service';
import { UserService } from 'src/app/common/user/user.service';
import { FooterComponent } from '../../_shared/components/footer/footer.component';
import { HeaderComponent } from '../../_shared/components/header/header.component';

@Component({
  selector: 'sharry-recommendation-create-introduction',
  templateUrl: './recommendation-create-introduction.component.html',
  styleUrls: ['./recommendation-create-introduction.component.scss'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    RouterLink,
    MatButtonModule,
    I18NextModule,
    RouteTranslatePipe,
    MatExpansionModule,
    IconComponent,
    HeaderComponent,
    FooterComponent,
    HeroComponent,
  ],
})
export class RecommendationCreateIntroductionComponent extends BaseComponent implements OnInit, OnDestroy {
  heroImages = [
    {
      ['480']: 'https://media.sharry.land/app/images/wonder-reccomandation/hero-768_480.webp',
      ['768']: 'https://media.sharry.land/app/images/wonder-reccomandation/hero-768_480.webp',
      ['1024']: 'https://media.sharry.land/app/images/wonder-reccomandation/hero-1024.webp',
      ['1440']: 'https://media.sharry.land/app/images/wonder-reccomandation/hero-1440.webp',
      ['1920']: 'https://media.sharry.land/app/images/wonder-reccomandation/hero-1920.webp',
      title: '',
      subtitle: '',
      textColor: '',
    },
  ];
  accordionPanels: { id: string; title: string; desc: string }[] = [
    {
      id: 'panel-1',
      title: 'recommendation-create-introduction.questions-subtitle-1',
      desc: 'recommendation-create-introduction.questions-content-1',
    },
    {
      id: 'panel-2',
      title: 'recommendation-create-introduction.questions-subtitle-2',
      desc: 'recommendation-create-introduction.questions-content-2',
    },
    {
      id: 'panel-3',
      title: 'recommendation-create-introduction.questions-subtitle-3',
      desc: 'recommendation-create-introduction.questions-content-3',
    },
    {
      id: 'panel-4',
      title: 'recommendation-create-introduction.questions-subtitle-4',
      desc: 'recommendation-create-introduction.questions-content-4',
    },
  ];

  constructor(
    public userService: UserService,
    private renderer: Renderer2,
    private router: Router,
    private routeTranslateService: RouteTranslateService,
    private notLoggedService: NotLoggedService,
    private ngZone: NgZone,
    @Inject(DOCUMENT) private document: Document,
    @Inject(METADATA_SERVICE) private metadataService: MetadataService,
    private location: Location,
  ) {
    super();
    this.metadataService.setMetadataPage('recommendation-create-introduction', this.location.path());
  }

  ngOnInit() {
    this.renderer.addClass(this.document.querySelector('html'), 'shrink');
    if (typeof this.document.body?.scroll === 'function') this.document.body.scroll(0, 0);
    if (typeof this.document.querySelector('.app-wrapper')?.scrollTo === 'function')
      this.document.querySelector('.app-wrapper')?.scrollTo(0, 0);
  }

  ngOnDestroy(): void {
    this.renderer.removeClass(this.document.querySelector('html'), 'shrink');
    this.metadataService.clean();
  }

  goToCreate() {
    if (this.isPlatformBrowser()) {
      const f = () =>
        this.ngZone.runOutsideAngular(() =>
          setTimeout(
            () => this.router.navigate([this.routeTranslateService.translateRoute('recommendation-management')]),
            1,
          ),
        );
      this.notLoggedService.execute(() => f());
    }
  }
}
